<script lang="ts">
  import NewEmployeeModal from "./NewEmployeeModal.svelte";
  import PermissionsInfoCard from "./PermissionsInfoCard.svelte";
  import type { RetailerUser } from "@shared/types/User";
  import * as _ from "lodash";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import retailerRoleFilter from "@retailer/filters/retailer_role.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import SettingsPageWrapper from "@modern/components/retailer/settings/PageWrapper.svelte";

  export let users: RetailerUser[];

  let showPermissions = false;
  let autoWidth = true; // used for styling table inline in the add user modal
  let paymentsEnabled = window["$rootScope"].user.term_payments;

  const initialModalState = function () {
    return {
      open: false,
      user: { email: null, role: null, first_name: null, last_name: null },
      isExistingUserCheckComplete: false,
      needToCreateNewUser: false,
    };
  };
  let modal = initialModalState();

  const openModal = function () {
    modal = initialModalState();
    modal.open = true;
  };

  const showInfoCard = function () {
    showPermissions = !showPermissions;
    autoWidth = false;
  };

  const englishRole = function (r) {
    return retailerRoleFilter()(r);
  };

</script>

<SettingsPageWrapper>
  <div class="padding--small">
    <div class="grid-row padding-bottom--small">
      <div class="grid-col c3-12 vertical-align-middle">
        <span class="default-title--regular margin-bottom--smaller show--md">Employees</span>
      </div>
      <div class="grid-col c9-12 vertical-align-middle align-right">
        <button class="button button--label button--small--md button--primary" on:click={openModal}
          >Add Account</button
        >
      </div>
    </div>

    {#if users.length}
      <div class="tile">
        <div class="tile__row padding--default">
          <div class="grid-row">
            <div class="grid-col c4-12">
              <div class="s6 strong">Name</div>
            </div>
            <div class="grid-col c5-12">
              <div class="s6 strong">Email</div>
            </div>
            <div class="grid-col c3-12" style="display: inline-flex;">
              <div class="s6 strong">Role</div>
              <Icon
                type="Info"
                height="16"
                width="16"
                className="margin-left--smallest cursor-pointer info-card-link"
                onPress={showInfoCard}
              />
            </div>
          </div>
        </div>

        {#if showPermissions}
          <div
            style="background: #FFFFFF; box-shadow: 0px 3px 5px rgba(89, 89, 89, 0.25), 0px 0px 1px rgba(89, 89, 89, 0.3);"
          >
            <div style="margin: 18px 20px;" class="fizz-styles">
              <PermissionsInfoCard {autoWidth} {paymentsEnabled} />
            </div>
          </div>
        {/if}

        {#each users as user}
          <div class="tile__row tile__row--hoverable cursor-pointer">
            <UIRouterLink stateName="layout.user_details" params={{ userId: user.id }}>
              <div class="padding--default" user-id={user.id}>
                <div class="grid-row">
                  <div class="grid-col c4-12">
                    <div class="s6 ellipsis color-brandPrimary notranslate">
                      {user.first_name}
                      {user.last_name}
                    </div>
                  </div>
                  <div class="grid-col c5-12">
                    <div class="s6 ellipsis notranslate">{user.email}</div>
                  </div>
                  <div class="grid-col c3-12">
                    <div class="s6 notranslate">{englishRole(user.role)}</div>
                  </div>
                </div>
              </div>
            </UIRouterLink>
          </div>
        {/each}
      </div>
    {/if}
  </div>

  <NewEmployeeModal bind:modal {autoWidth} bind:users />
</SettingsPageWrapper>
